import { gql } from '@apollo/client/core';

import LocationService from '@/services/LocationService';
import { executeQuery } from '@/components/commons/utils.js';

const PING_QUERY = gql`
  query PING($postalCode: String) {
    customerSession {
      sessionId
      email
      firstName
      lastName
      verified
      expired
      registered
      isTrade
      cart {
        cartItems {
          quantity
        }
      }
      token
    }
    office
    getLocationByIP {
      location {
        country
        currency
        region {
          id
          name
          code
        }
        city
        postalCode
        accuracy
      }
    }
    getLocationByPostalCode(postalCode: $postalCode) {
      location {
        country
        currency
        region {
          id
          name
          code
        }
        city
        postalCode
        accuracy
      }
    }
  }
`;

export default class SessionService {
  static async ping(zip) {
    const zipcode = zip || LocationService.getPreferredLocation().zipcode;

    try {
      const result = await executeQuery(PING_QUERY, {
        postalCode: zipcode,
      });

      const { customerSession, office, getLocationByIP: geoLocation, getLocationByPostalCode: zipLocation } = result;

      return {
        user: {
          ...customerSession,
        },
        customerToken: customerSession?.token,
        office,
        geoLocation: geoLocation?.location
          ? {
            accuracyRadius: geoLocation.location.accuracy,
            countryId: geoLocation.location.country === 'CA' ? 1 : 2,
            countryCode: geoLocation.location.country,
            regionId: geoLocation.location.region?.id,
            regionCode: geoLocation.location.region?.code,
            city: geoLocation.location.city,
            currencyId: geoLocation.location.currency === 'CAD' ? 2 : 1,
            zipcode: geoLocation.location.postalCode,
          }
          : LocationService.getDefaultLocation(),
        zipLocation: zipLocation?.location
          ? {
            accuracyRadius: zipLocation.location.accuracy,
            countryId: zipLocation.location.country === 'CA' ? 1 : 2,
            countryCode: zipLocation.location.country,
            regionId: zipLocation.location.region?.id,
            regionCode: zipLocation.location.region?.code,
            city: zipLocation.location.city,
            currencyId: zipLocation.location.currency === 'CAD' ? 2 : 1,
            zipcode: zipLocation.location.postalCode,
          }
          : null,
      };
    } catch (error) {
      console.error(error);
      return {
        error,
      };
    }
  }
}
